module.exports = __webpack_public_path__ + "img/check_box.70ff0850.png";